import { getTokenName } from './get-token-name';

export const removeTokenFromStorage = () => {
  const tokenName = getTokenName();
  localStorage.removeItem(tokenName);
};
